import { Injectable } from '@angular/core';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from '../../../../Autofacets-Core/src/app/utils/urls';

@Injectable({ providedIn: 'root' })
export class AutomaticUpdatesDataService {
    constructor(
        private dataProvider: DataService
    ) { }

    GetList(model: any): Promise<any> {
        return this.dataProvider.Post<any>(Urls.AutomaticUpdatesList,model).toPromise();
    }
    Update(model: any): Promise<any> {
        return this.dataProvider.Post<any>(Urls.AutomaticUpdatesSave, model).toPromise();
    }
}